/**
 * Deep link UI constants and shared query keys.
 */

/** Labels shown on the deep link preview card for each link type. */
export const TYPE_LABELS: Record<string, { icon: string; title: string; description: string }> = {
  challenge: {
    icon: '🏆',
    title: "You've Been Challenged!",
    description: 'Join this sports prediction challenge and compete with friends!',
  },
  friend: {
    icon: '👋',
    title: "You've Been Invited!",
    description: 'Join Zporti to compete with friends in sports prediction challenges!',
  },
  group: {
    icon: '👥',
    title: 'Group Invite!',
    description: 'Join this group and compete in group challenges!',
  },
};

/** Query keys that must be refetched after a deep link is processed. */
export const DEEP_LINK_REFETCH_KEYS = [
  ['friends'],
  ['groups'],
  ['challenges'],
  ['challenges', 'active'],
  ['invitations'],
] as const;
